import { InMemoryCache } from "@apollo/client";

const apolloCache = new InMemoryCache({
  typePolicies: {
    Campaign: {
      fields: {
        calleeFields: {
          merge: (_existing: any[], incoming: any[]) => incoming
        }
      }
    },
    CampaignCalleeField: {
      keyFields: false // disable cacheing of callee fields
    },
    Tenant: {
      keyFields: ["slug"]
    }
  }
});

export default apolloCache;
